export default __webpack_public_path__ + "i18n/translations/translation-fr.27ad2e1a.json";